import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiImage, FiVideo, FiMic, FiGlobe, FiCpu, FiUsers, FiTrendingUp } = FiIcons;

const AppsShowcase = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const apps = [
    // Playground Apps
    {
      name: "Deep Research",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/689e86a42612cea195d949b4_9c074b84-8e1d-4b06-8a34-fc2c016e44cf_download-1.webp",
      description: "AI-powered research assistant that streamlines deep research and uncovers key insights"
    },
    {
      name: "Hero Images",
      category: "playground",
      image: "https://assistant.nextlevellocal.biz/assets/ai-apps/heroimages2.png",
      description: "AI-generated hero images that perfectly encapsulate your brand's essence"
    },
    {
      name: "AI Image Editor",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/59e506af-dd5a-4579-a1c3-ea2fd897f015.jpg",
      description: "Edit and enhance images with intelligent tools that automate tedious tasks"
    },
    {
      name: "Hyperrealistic AI Images",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/f93e9aa0-da17-49e3-a3fb-ce79600983ce.jpg",
      description: "Generate photograph-quality images with precision and ease"
    },
    {
      name: "Conversational Images",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/0d951378-91df-4091-9354-d6093698e5d9.jpg",
      description: "Edit images through simple conversation with AI"
    },
    {
      name: "AI Videos",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/393782d9-6824-4b19-ad8a-d6ffd1829068.jpg",
      description: "Create personalized videos tailored to your business"
    },
    {
      name: "Movie Editor",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/6305f8be-8554-487a-a598-e37911cc2913.jpg",
      description: "Transform your videos with easy editing tools"
    },
    {
      name: "Motion Maker",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/397f1e1a-b810-40b4-a50e-eed10a0ddff4.jpg",
      description: "Create dazzling motion graphics that stop customers in their tracks"
    },
    {
      name: "Audiobook Maker",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/98eb0673-f2d4-44e2-96e3-e77e5b533d33.jpg",
      description: "Transform words into captivating audiobooks with lifelike voices"
    },
    {
      name: "AI Voice Over",
      category: "playground",
      image: "https://d1xzp23rup9ttz.cloudfront.net/ai-apps/ai-voiceover.svg",
      description: "Create stunning voiceovers effortlessly with AI"
    },
    {
      name: "AI Music Generator",
      category: "playground",
      image: "https://d1xzp23rup9ttz.cloudfront.net/ai-apps/ai-music-generator.svg",
      description: "Generate tracks that hit the exact mood you're after"
    },
    {
      name: "Simple Websites",
      category: "playground",
      image: "https://app.deal.ai/assets/sidebarIcons/smart-websites.png",
      description: "Create stunning websites effortlessly with intuitive builder"
    },
    {
      name: "AEO Blogs",
      category: "playground",
      image: "https://d1xzp23rup9ttz.cloudfront.net/ai-apps/blogs.svg",
      description: "Create blog posts with AI assistance"
    },
    {
      name: "Next Level Creator",
      category: "playground",
      image: "https://d268zs2sdbzvo0.cloudfront.net/68896c0be01e9763627455c7_1828f67e-68b7-4bb4-bb30-34a7a602032b_NextLevel%20Favicon.jpg",
      description: "Transform ideas into fully functional web applications"
    },
    // Business Apps (showing a selection)
    {
      name: "AI Spokesperson",
      category: "business",
      image: "https://d268zs2sdbzvo0.cloudfront.net/7060963f-4b6a-4fa9-aae2-2f3978a189a9.jpg",
      description: "Create UGC videos in minutes with AI avatars"
    },
    {
      name: "Scroll-Stopping Ads",
      category: "business",
      image: "https://d268zs2sdbzvo0.cloudfront.net/4cd78e20-e5d9-44ba-bc54-44d4c300fcdc.jpg",
      description: "AI-crafted ads designed to stop them in their tracks"
    },
    {
      name: "Easy CRM",
      category: "business",
      image: "https://app.deal.ai/assets/sidebarIcons/quick_crm.png",
      description: "Simplify customer relationship management with AI"
    },
    {
      name: "Magic Hooks",
      category: "business",
      image: "https://d268zs2sdbzvo0.cloudfront.net/6ba8e575-5e55-451d-bb27-1fc7520416c3.jpg",
      description: "AI-generated hooks with high conversion rates"
    },
    {
      name: "Email Marketing",
      category: "business",
      image: "https://d268zs2sdbzvo0.cloudfront.net/f52104bb-8456-458a-9802-8027490ef67d.jpg",
      description: "AI-powered email campaigns with personalization"
    },
    {
      name: "AI Forms",
      category: "business",
      image: "https://d268zs2sdbzvo0.cloudfront.net/7a30e340-5981-4621-8806-ea7d5fac120f.jpg",
      description: "Create sleek, interactive forms in moments"
    },
    {
      name: "Super Agent",
      category: "business",
      image: "https://d1xzp23rup9ttz.cloudfront.net/ai-apps/super-agent.jpeg",
      description: "Powerful AI assistant ready to handle tasks"
    },
    {
      name: "White Label",
      category: "marketer",
      image: "https://d1xzp23rup9ttz.cloudfront.net/ai-apps/whitelabel.svg",
      description: "Customize and brand the platform as your own"
    }
  ];

  const filteredApps = activeCategory === 'all' ? apps : apps.filter(app => app.category === activeCategory);

  return (
    <section id="apps-showcase" className="py-24 bg-gradient-to-br from-gray-800 via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
            We Offer Over <span className="text-red-500">50+</span> Apps
          </h2>
          <p className="text-2xl text-gray-300 mb-8">Inside Your Assistant</p>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            🚀 No stress. No skills needed. Just type, click, and wow yourself!
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex justify-center gap-4 mb-12 flex-wrap"
        >
          {['all', 'playground', 'business', 'marketer'].map((category) => (
            <motion.button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-full font-bold transition-all ${
                activeCategory === category 
                  ? 'bg-gradient-to-r from-yellow-400 to-pink-500 text-black' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </motion.button>
          ))}
        </motion.div>

        {/* Apps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredApps.map((app, index) => (
            <motion.div
              key={app.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="group"
            >
              <div className="bg-gray-800 border border-gray-700 rounded-2xl overflow-hidden hover:border-yellow-500/50 transition-all duration-300 group-hover:transform group-hover:scale-105">
                <div className="aspect-video bg-gradient-to-br from-yellow-400/20 to-pink-500/20 flex items-center justify-center p-4">
                  <img src={app.image} alt={app.name} className="w-full h-full object-contain" />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors">
                    {app.name}
                  </h3>
                  <p className="text-sm text-gray-400 line-clamp-2">
                    {app.description}
                  </p>
                  <div className="mt-2">
                    <span className="inline-block px-2 py-1 bg-gradient-to-r from-blue-500 to-purple-500 text-white text-xs rounded-full">
                      {app.category}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <motion.a
            href="https://buy.stripe.com/4gMeVe5Ep3Ml3CK9bk6Vq04"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-12 py-6 bg-gradient-to-r from-yellow-400 to-pink-500 text-black text-xl font-black rounded-full transform transition-all duration-300 hover:scale-110"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Access To All 50+ Apps! 🎯
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default AppsShowcase;